const getStatuses = (t) => [
  {
    value: 0,
    label: t('closed'),
  },
  {
    value: -1,
    label: t('confirmed'),
  },
  {
    value: -2,
    label: t('inProgress'),
  },
  {
    value: -3,
    label: t('canceled'),
  },
];

// For backwards compatibility - returns keys instead of translated values
const statuses = [
  { value: 0, label: 'closed' },
  { value: -1, label: 'confirmed' },
  { value: -2, label: 'inProgress' },
  { value: -3, label: 'canceled' },
];

export { getStatuses };
export default statuses;
